export enum SessionAnalysisType {
  DISCARDED = 0, // Team-Singleton
  DISCARDED_ARCHIVE = 10, // Team-Singleton (Hidden)
  REFERENCE_CALIBRATIONS = 100, // Team-Singleton
  FREERIDE_UNSTRUCTURED = 300, // Team-Singleton
  TRAVERSE = 1000,
  TRAVERSE_TYRE_REFERENCE = 1050,
  TRAVERSE_TYRE_COMPARISON = 1060,
  TRAVERSE_INDOORS = 1200,
  TRAVERSE_INDOORS_CONSTANT_GRADIENT = 1210, // Catesby
  LOOP = 2000,
  LOOP_VELODROME_OUTDOORS = 2100,
  LOOP_VELODROME_INDOORS = 2200,
  FREERIDE_CALIBRATED = 3000,
}

export enum CalibrationRefType {
  FACTORY = 0,
  TEAM = 1,
}

export enum SessionStatus {
  AVAILABLE = 0,
  BETA = 1,
  COMING_SOON = 2,
  IN_DEVELOPMENT = 3,
}

export const SessionCatalog = {
  [SessionAnalysisType.TRAVERSE]: ['Traverse Aero Test', 0, SessionStatus.AVAILABLE],
  [SessionAnalysisType.FREERIDE_CALIBRATED]: ['Free Ride - With Calibrations', 1, SessionStatus.AVAILABLE],
  [SessionAnalysisType.TRAVERSE_TYRE_REFERENCE]: ['Rolling Resistance - Reference', 2, SessionStatus.BETA],
  [SessionAnalysisType.TRAVERSE_TYRE_COMPARISON]: ['Rolling Resistance - Comparison', 3, SessionStatus.BETA],
  [SessionAnalysisType.LOOP_VELODROME_OUTDOORS]: ['Velodrome - Outdoors', 4, SessionStatus.BETA],
  [SessionAnalysisType.LOOP_VELODROME_INDOORS]: ['Velodrome - Indoors', 5, SessionStatus.BETA],
  [SessionAnalysisType.TRAVERSE_INDOORS_CONSTANT_GRADIENT]: ['Catesby', 6, SessionStatus.BETA],
  [SessionAnalysisType.LOOP]: ['Circuit', 7, SessionStatus.IN_DEVELOPMENT],
};

export class SessionAnalysisTypeUtils {
  static isSingletonLevel(level: number): boolean {
    return level < this.singletonLevel();
  }

  static singletonLevel(): number {
    return 1000;
  }

  static isValid(analysisType: number): boolean {
    return analysisType >= SessionAnalysisType.FREERIDE_UNSTRUCTURED;
  }

  static isSession(analysisType: number): boolean {
    return analysisType >= SessionAnalysisType.TRAVERSE && analysisType < SessionAnalysisType.FREERIDE_CALIBRATED;
  }

  // Sessions a run can be moved into. Mirrors the server's `with_configs_min`
  // scope filter (`analysis_type >= TRAVERSE`), which is what populates the
  // move dropdown — the singletons below TRAVERSE are never offered as targets.
  // Distinct from `isSession`, whose exclusive upper bound is there to keep
  // FREERIDE_CALIBRATED in the run list's "free ride" bucket; used as a move
  // filter it silently hides every calibrated free-ride session.
  static isMoveTarget(analysisType: number): boolean {
    return analysisType >= SessionAnalysisType.TRAVERSE;
  }

  // The bound is inclusive: FREERIDE_CALIBRATED itself is a free ride. With a
  // strict `>` it matched neither this nor `isSession` (whose upper bound is
  // exclusive), so a calibrated free ride's runs disappeared from both of the
  // run list's filters at once.
  static isFreeRide(analysisType: number): boolean {
    return (
      analysisType === SessionAnalysisType.FREERIDE_UNSTRUCTURED ||
      analysisType >= SessionAnalysisType.FREERIDE_CALIBRATED
    );
  }

  static isDiscarded(analysisType: number): boolean {
    return analysisType === SessionAnalysisType.DISCARDED;
  }

  static isHidden(analysisType: number): boolean {
    return analysisType === SessionAnalysisType.DISCARDED_ARCHIVE;
  }
}
